export default [
  {
    key: 'branchOfficeName',
    label: '支店',
    style: {
    }
  }, 
  {
    key: 'departmentName',
    label: '部署',
    style: {
    }
  }, 
  {
    key: 'name',
    label: '社員名',
    style: {
    }
  }, 
  // {
  //   key: 'email',
  //   label: 'ログインID',
  //   style: {
  //   }
  // }, 
  // {
  //   key: 'paidHoliday',
  //   label: '残有給',
  //   style: {
  //     width: 80,
  //     overflow: 'hidden'
  //   }
  // }, 
  // {
  //   key: 'priceName',
  //   label: '時間単価',
  //   style: {
  //     width: 100,
  //     overflow: 'hidden'
  //   }
  // }, 
  {
    key: 'permissionName',
    label: '権限',
    style: {
    }
  }, 
  {
    key: 'actions',
    label: '',
    style: {
    }
  },
];


// WEBPACK FOOTER //
// ./src/containers/master/user/listHeader.js